export const ONE_MONTH_IN_MILLISECONDS = 30 * 24 * 60 * 60 * 1000;

export const room_status = {
  "0": "Trống",
  "1": "Đã cọc, chưa vào ở",
  "2": "Đã nhận phòng",
  "3": "Báo trả phòng",
  "4": "Báo trả phòng và đã có cọc mới",
};

export const list_building = [
  { text: "Bảo Ngọc", value: "BN" },
  { text: "Gia Bảo", value: "GB" },
  { text: "Thanh Tâm", value: "TT" },
  { text: "Xuân Anh", value: "XA" },
  { text: "Mai Anh", value: "MA" },
  { text: "B Minh Tâm", value: "MT" },
];

export const ACCOUNT_CATEGORY = {
  CASH: "cash",
  BANK: "bank",
  INCOME: "income",
  EXPENSE: "expense",
  OTHER: "other",
};

export const ACCOUNT_TYPES = {
  // Cash Accounts
  CASH_BAO_NGOC: "Tiền mặt Bảo Ngọc",
  CASH_GIA_BAO: "Tiền mặt Gia Bảo",
  CASH_THANH_TAM: "Tiền mặt Thanh Tâm",
  CASH_XUAN_ANH: "Tiền mặt Xuân Anh",
  CASH_MAI_ANH: "Tiền mặt Mai Anh",

  // Bank Accounts
  BIDV_MRS_GAM: "Ngân hàng BIDV C.Gam",
  BIDV_MRS_YEN: "Ngân hàng BIDV C.Yen",
  VCB_MRS_GAM: "Ngân hàng VCB C.Gam",
  VCB_M_TAM: "Ngân hàng VCB M.Tam",

  // Others
  CUSTOMER_ACCOUNT_RECEIVALBE: "customer_account_receivable", // Phải thu khách hàng
  MRS_GAM_ACCOUNT_RECEIVALBE: "mrs_gam_receivable", // Công nợ cô Gấm
  ACCOUNT_PAYABLE: "account_payable", // Nợ phải trả
  LONG_TERM_LOAN: "long_term_loan", // Vay dài hạn
  PENSION: "pension", // Lương hưu
  EQUITY: "equity", // Vốn chủ sở hữu
  PREVIOUS_PERIOD_UNDISTRIBUTED_EARNINGS:
    "previous_period_undistributed_earnings", // Lợi nhuận chưa phân phối kỳ trước
  THIS_PERIOD_UNDISTRIBUTED_EARNINGS: "this_period_undistributed_earnings", // Lợi nhuận chưa phân phối kỳ này

  // Income
  ROOM_REVENUE: "room_revenue",
  DEPOSIT_REVENUE: "deposit_revenue",
  ROOM_REVENUE_ADJUSTMENT: "room_revenue_adjustment",
  RECEIPT_ROOM: "receipt_room",
  RECEIPT_OTHER: "receipt_other",
  RETURN_DEPOSIT: "return_deposit",
  ADDITIONAL_DEPOSIT: 'additional_deposit_receipt',

  // Expense
  MANAGEMENT_STAFF_SALARY: "management_staff_salary",
  GUARD_SALARY: "guard_salary",
  LOCAL_MILITITA: "local_militita",
  WATER: "water",
  ELECTRICITY: "electricity",
  LAND_RENT: "land_rent",
  LAND_TAX: "land_tax",
  LOAN_INTEREST: "loan_interest",
  REPAIR: "repair",
  MATERIAL_PURCHASE: "material_purchase",
  WASTE_MANAGEMENT: "waste_management",
  ADVERTISING: "advertising",
  INTERNET: "internet",
  OTHER: "other",
  UTILITY_RECORDING: "utility_recording",
  COMMISSION: "commission",
  TELEPHONE: "telephone",
  EMPLOYEE_WAGE: "employee_wage",
  RETURN_DEPOSIT_CANCELLED: 'return_deposit_cancelled',
  RETURN_LOAN: 'return_loan',
};

export const ACCOUNTING_ACCOUNT_DISPLAY_NAME_MAPPING = {
  1111: 'TM B.Ngoc',
	1112: 'TM G.Bao',
	1113: 'TM T.Tam',
	1114: 'TM X.Anh',
	1115: 'TM M.Anh',

  1121: 'BIDV C.Gam',
	1122: 'BIDV C.Yen',
	1123: 'VCB C.Gam',
	1124: 'VCB M.Tam',

  1311: 'Phải thu khách hàng',
  1381: 'Công nợ cô Gấm',
  1388: "Phải thu khác",
  3311: "Nợ phải trả",
  3411: "Vay",
  3388:  "Lương hưu",
  4111: "Vốn chủ sở hữu",
  4211: "Lợi nhuận chưa phân phối kỳ trước",
  4212: "Lợi nhuận chưa phân phối kỳ này",

  5111: "Doanh thu tiền phòng",
  5112: "Doanh thu tiền cọc",
  5211: "Điều chỉnh tiền phòng",
	5212: 'Chi trả cọc',
  7111: 'Thu khác',
  7112: 'Thu khác',

	6321: 'Chi phí lương và quản lý',
	6322: 'Chi phí nước',
	6323: 'Chi phí điện',
	6324: 'Chi phí thuê đất',
  6327: 'Chi phí thuế đất',
  6325: 'Chi phí rác, vệ sinh',
  6326: 'Chi phí internet',
  6351: "Chi phí lãi vay",
  6411: "Chi phí quảng cáo",

	8111: 'Chi mua vật tư và sửa chữa',
	8112: 'Chi phí dẫn phòng',
	8113: 'Chi phí khác',
};

export const WALLET_ID_AND_ACCOUNT_TYPE_MAP = {
  // 1: "éo có",
  2: ACCOUNT_TYPES.VCB_MRS_GAM,
  3: ACCOUNT_TYPES.BIDV_MRS_GAM,
  4: ACCOUNT_TYPES.VCB_M_TAM,
  5: ACCOUNT_TYPES.BIDV_MRS_YEN,
  6: ACCOUNT_TYPES.CASH_BAO_NGOC,
  7: ACCOUNT_TYPES.CASH_GIA_BAO,
  8: ACCOUNT_TYPES.CASH_THANH_TAM,
  9: ACCOUNT_TYPES.CASH_XUAN_ANH,
  10: ACCOUNT_TYPES.CASH_MAI_ANH,
};

export const ACCOUNTS = {
  [ACCOUNT_TYPES.CASH_BAO_NGOC]: {
    account: ACCOUNT_TYPES.CASH_BAO_NGOC,
    accounting_account: 1111,
    text: "TM B.Ngoc",
    category: ACCOUNT_CATEGORY.CASH,
  },
  [ACCOUNT_TYPES.CASH_GIA_BAO]: {
    account: ACCOUNT_TYPES.CASH_GIA_BAO,
    accounting_account: 1112,
    text: "TM G.Bao",
    category: ACCOUNT_CATEGORY.CASH,
  },
  [ACCOUNT_TYPES.CASH_THANH_TAM]: {
    account: ACCOUNT_TYPES.CASH_THANH_TAM,
    accounting_account: 1113,
    text: "TM T.Tam",
    category: ACCOUNT_CATEGORY.CASH,
  },
  [ACCOUNT_TYPES.CASH_XUAN_ANH]: {
    account: ACCOUNT_TYPES.CASH_XUAN_ANH,
    accounting_account: 1114,
    text: "TM X.Anh",
    category: ACCOUNT_CATEGORY.CASH,
  },
  [ACCOUNT_TYPES.CASH_MAI_ANH]: {
    account: ACCOUNT_TYPES.CASH_MAI_ANH,
    accounting_account: 1115,
    text: "TM M.Anh",
    category: ACCOUNT_CATEGORY.CASH,
  },
  [ACCOUNT_TYPES.BIDV_MRS_GAM]: {
    account: ACCOUNT_TYPES.BIDV_MRS_GAM,
    accounting_account: 1121,
    text: "BIDV C.Gam",
    category: ACCOUNT_CATEGORY.BANK,
  },
  [ACCOUNT_TYPES.BIDV_MRS_YEN]: {
    account: ACCOUNT_TYPES.BIDV_MRS_YEN,
    accounting_account: 1122,
    text: "BIDV C.Yen",
    category: ACCOUNT_CATEGORY.BANK,
  },
  [ACCOUNT_TYPES.VCB_MRS_GAM]: {
    account: ACCOUNT_TYPES.VCB_MRS_GAM,
    accounting_account: 1123,
    text: "VCB C.Gam",
    category: ACCOUNT_CATEGORY.BANK,
  },
  [ACCOUNT_TYPES.VCB_M_TAM]: {
    account: ACCOUNT_TYPES.VCB_M_TAM,
    accounting_account: 1124,
    text: "VCB M.Tam",
    category: ACCOUNT_CATEGORY.BANK,
  },
  [ACCOUNT_TYPES.CUSTOMER_ACCOUNT_RECEIVALBE]: {
    account: ACCOUNT_TYPES.CUSTOMER_ACCOUNT_RECEIVALBE,
    accounting_account: 1311,
    text: "Phải thu khách hàng",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.MRS_GAM_ACCOUNT_RECEIVALBE]: {
    account: ACCOUNT_TYPES.MRS_GAM_ACCOUNT_RECEIVALBE,
    accounting_account: 1381,
    text: "Công nợ cô Gấm",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.ACCOUNT_PAYABLE]: {
    account: ACCOUNT_TYPES.ACCOUNT_PAYABLE,
    accounting_account: 3311,
    text: "Nợ phải trả",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.LONG_TERM_LOAN]: {
    account: ACCOUNT_TYPES.LONG_TERM_LOAN,
    accounting_account: 3411,
    text: "Vay",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.PENSION]: {
    account: ACCOUNT_TYPES.PENSION,
    accounting_account: 3388,
    text: "Lương hưu",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.EQUITY]: {
    account: ACCOUNT_TYPES.EQUITY,
    accounting_account: 4111,
    text: "Vốn chủ sở hữu",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.PREVIOUS_PERIOD_UNDISTRIBUTED_EARNINGS]: {
    account: ACCOUNT_TYPES.PREVIOUS_PERIOD_UNDISTRIBUTED_EARNINGS,
    accounting_account: 4211,
    text: "Lợi nhuận chưa phân phối kỳ trước",
    category: ACCOUNT_CATEGORY.OTHER,
  },
  [ACCOUNT_TYPES.THIS_PERIOD_UNDISTRIBUTED_EARNINGS]: {
    account: ACCOUNT_TYPES.THIS_PERIOD_UNDISTRIBUTED_EARNINGS,
    accounting_account: 4212,
    text: "Lợi nhuận chưa phân phối kỳ này",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.RETURN_DEPOSIT]: {
    account: ACCOUNT_TYPES.RETURN_DEPOSIT,
    accounting_account: 5212,
    text: "Chi trả cọc",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED]: {
    account: ACCOUNT_TYPES.RETURN_DEPOSIT_CANCELLED,
    accounting_account: 5212,
    text: "Chi trả cọc (khách đã hủy cọc)",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.ADDITIONAL_DEPOSIT]: {
    account: ACCOUNT_TYPES.ADDITIONAL_DEPOSIT,
    accounting_account: 5212,
    text: "Chi trả cọc",
    category: ACCOUNT_CATEGORY.INCOME,
  },
  [ACCOUNT_TYPES.MANAGEMENT_STAFF_SALARY]: {
    account: ACCOUNT_TYPES.MANAGEMENT_STAFF_SALARY,
    accounting_account: 6321,
    text: "Chi lương quản lý",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.GUARD_SALARY]: {
    account: ACCOUNT_TYPES.GUARD_SALARY,
    accounting_account: 6321,
    text: "Chi lương bảo vệ",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.LOCAL_MILITITA]: {
    account: ACCOUNT_TYPES.LOCAL_MILITITA,
    accounting_account: 6321,
    text: "Chi cán bộ dân phòng",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.WATER]: {
    account: ACCOUNT_TYPES.WATER,
    accounting_account: 6322,
    text: "Chi tiền nước",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.ELECTRICITY]: {
    account: ACCOUNT_TYPES.ELECTRICITY,
    accounting_account: 6323,
    text: "Chi tiền điện",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.LAND_RENT]: {
    account: ACCOUNT_TYPES.LAND_RENT,
    accounting_account: 6324,
    text: "Chi tiền thuê đất",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.LAND_TAX]: {
    account: ACCOUNT_TYPES.LAND_TAX,
    accounting_account: 6327,
    text: "Chi tiền thuế đất",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.LOAN_INTEREST]: {
    account: ACCOUNT_TYPES.LOAN_INTEREST,
    accounting_account: 6351,
    text: "Chi trả lãi vay",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.REPAIR]: {
    account: ACCOUNT_TYPES.REPAIR,
    accounting_account: 8111,
    text: "Chi tiền sửa chữa",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.MATERIAL_PURCHASE]: {
    account: ACCOUNT_TYPES.MATERIAL_PURCHASE,
    accounting_account: 8111,
    text: "Chi mua vật tư",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.WASTE_MANAGEMENT]: {
    account: ACCOUNT_TYPES.WASTE_MANAGEMENT,
    accounting_account: 6325,
    text: "Chi tiền rác, vệ sinh",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.ADVERTISING]: {
    account: ACCOUNT_TYPES.ADVERTISING,
    accounting_account: 6411,
    text: "Chi quảng cáo",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.INTERNET]: {
    account: ACCOUNT_TYPES.INTERNET,
    accounting_account: 6326,
    text: "Chi phí internet",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.OTHER]: {
    account: ACCOUNT_TYPES.OTHER,
    accounting_account: 8113,
    text: "Chi khác",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.UTILITY_RECORDING]: {
    account: ACCOUNT_TYPES.UTILITY_RECORDING,
    accounting_account: 8113,
    text: "Chi ghi điện, nước",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.COMMISSION]: {
    account: ACCOUNT_TYPES.COMMISSION,
    accounting_account: 8112,
    text: "Chi dẫn phòng",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.TELEPHONE]: {
    account: ACCOUNT_TYPES.TELEPHONE,
    accounting_account: 8113,
    text: "Chi tiền điện thoại",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.EMPLOYEE_WAGE]: {
    account: ACCOUNT_TYPES.EMPLOYEE_WAGE,
    accounting_account: 8113,
    text: "Chi lương (cũ)",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.RETURN_LOAN]: {
    account: ACCOUNT_TYPES.RETURN_LOAN,
    accounting_account: 3411,
    text: "Chi trả nợ vay",
    category: ACCOUNT_CATEGORY.EXPENSE,
  },
  [ACCOUNT_TYPES.ROOM_REVENUE]: {
    account: ACCOUNT_TYPES.ROOM_REVENUE,
    accounting_account: 5111,
    text: "Doanh thu tiền phòng",
    category: ACCOUNT_CATEGORY.INCOME,
  },
  [ACCOUNT_TYPES.DEPOSIT_REVENUE]: {
    account: ACCOUNT_TYPES.DEPOSIT_REVENUE,
    accounting_account: 5112,
    text: "Doanh thu tiền cọc",
    category: ACCOUNT_CATEGORY.INCOME,
  },
  [ACCOUNT_TYPES.ROOM_REVENUE_ADJUSTMENT]: {
    account: ACCOUNT_TYPES.ROOM_REVENUE_ADJUSTMENT,
    accounting_account: 5211,
    text: "Điều chỉnh tiền phòng",
    category: ACCOUNT_CATEGORY.INCOME,
  },
  [ACCOUNT_TYPES.RECEIPT_ROOM]: {
    account: ACCOUNT_TYPES.RECEIPT_ROOM,
    accounting_account: 7111,
    text: "Thu khác",
    category: ACCOUNT_CATEGORY.INCOME,
  },
  [ACCOUNT_TYPES.RECEIPT_OTHER]: {
    account: ACCOUNT_TYPES.RECEIPT_OTHER,
    accounting_account: 7111,
    text: "Thu khác",
    category: ACCOUNT_CATEGORY.INCOME,
  },
};

/**
 * Get account key list by type
 * @param {string | string[]} categories
 * @returns {string[]}
 * @example
 * getAccountTypeListByCategory('cash') // ['CASH_BAO_NGOC', 'CASH_GIA_BAO', 'CASH_THANH_TAM', 'CASH_XUAN_ANH', 'CASH_MAI_ANH']
 */
const getAccountTypeListByCategory = (categories) => {
  const categoriesArray = Array.isArray(categories) ? categories : [categories];
  return Object.keys(ACCOUNTS).filter((key) =>
    categoriesArray.includes(ACCOUNTS[key].category)
  );
};

export const CASH_ACCOUNT_TYPE_LIST = getAccountTypeListByCategory(
  ACCOUNT_CATEGORY.CASH
);

export const BANK_ACCOUNT_TYPE_LIST = getAccountTypeListByCategory(
  ACCOUNT_CATEGORY.BANK
);

export const CASH_AND_BANK_ACCOUNT_TYPE_LIST = getAccountTypeListByCategory([
  ACCOUNT_CATEGORY.CASH,
  ACCOUNT_CATEGORY.BANK,
]);

export const EXPENSE_ACCOUNT_TYPE_LIST = getAccountTypeListByCategory(
  ACCOUNT_CATEGORY.EXPENSE
);

export const INCOME_ACCOUNT_TYPE_LIST = getAccountTypeListByCategory(
  ACCOUNT_CATEGORY.INCOME
);

/**
 * Get account list by type
 * @param {string | string[]} categories
 * @returns {object}
 * @example
 * getAccountListByCategory('cash') // { Tiền mặt Bảo Ngọc: { account: 'TM B.Ngoc', accounting_account: 1111, text: 'TM B.Ngoc', category: 'cash' }, ... }
 */
const getAccountListByCategory = (categories) => {
  const categoriesArray = Array.isArray(categories) ? categories : [categories];
  return Object.entries(ACCOUNTS)
    .filter(([_, value]) => categoriesArray.includes(value.category))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
};

export const CASH_AND_BANK_ACCOUNT_LIST = getAccountListByCategory([
  ACCOUNT_CATEGORY.CASH,
  ACCOUNT_CATEGORY.BANK,
]);

export const EXPENSE_ACCOUNT_LIST = getAccountListByCategory(
  ACCOUNT_CATEGORY.EXPENSE
);

/**
 * Get account options by type
 * @param {string | string[]} categories
 * @returns {object[]}
 * @example
 * getAccountOptionsByCategory('cash') // [{ text: 'TM B.Ngoc', value: 'CASH_BAO_NGOC' }, ...]
 */
const getAccountOptionsByCategory = (categories) => {
  const categoriesArray = Array.isArray(categories) ? categories : [categories];

  return Object.entries(ACCOUNTS)
    .filter(
      ([accountType, accountData]) =>
        categoriesArray.includes(accountData.category) ||
        [
          ACCOUNT_TYPES.RETURN_DEPOSIT,
          ACCOUNT_TYPES.MRS_GAM_ACCOUNT_RECEIVALBE,
        ].includes(accountType)
    )
    .reduce((acc, [_, accountData]) => {
      acc.push({ text: accountData.text, value: accountData.account });
      return acc;
    }, []);
};

export const EXPENSE_ACCOUNT_OPTIONS = getAccountOptionsByCategory(
  ACCOUNT_CATEGORY.EXPENSE
);

export const INCOME_ACCOUNT_OPTIONS = getAccountOptionsByCategory(
  ACCOUNT_CATEGORY.INCOME
);

export const INCOME_AND_EXPENSE_ACCOUNT_OPTIONS = getAccountOptionsByCategory([
  ACCOUNT_CATEGORY.INCOME,
  ACCOUNT_CATEGORY.EXPENSE,
]);

export const BANK_LIST = {
	BIDV: "BIDV",
	VCB: "VCB",
};

export const CASH_ACCOUNT_ID_TO_BUILDING_MAPPING = {
  6: "BN",
  7: "GB",
  8: "TT",
  9: "XA",
  10: "MA",
};
export const BUILDING_TO_CASH_ACCOUNT_ID_MAPPING = {
  "BN": 6,
  "GB": 7,
  "TT": 8,
  "XA": 9,
  "MA": 10,
  "MT": 10,
};

export const BANK_WALLET_ACCOUNT_IDS = [2,3,4,5];
export const CASH_WALLET_ACCOUNT_IDS = [6,7,8,9,10];

const LOAN_OBJECTS = [
  "TKV 188000119247",
  "TKV 188000125575",
  "TKV 188000127137",
  "TKV 188000129625",
  "TKV 188000131582",
  "TKV 188000133667",
  "TKV 188000136317",
  "TKV 188000138795",
  "TKV 188000141429",
  "TKV 188000142984",
  "TKV 188000144629",
  "TKV 1027407738",
  "TKV 1028730842",
  "TKV 1030048703",
  "TKV 1031315705",
  "TKV 1029217719",
  "TKV 0188000148274", // Anh Hiền đứng tên vay
  "TKV 1027885211", // Anh Hiền đứng tên vay
  "Thông",
  "Chị Liên",
  "Chị Năm",
  "Chú Mạnh",
  "Anh Hiền",
  "Hữu Thành"
];

export const LOAN_OBJECT_OPTIONS = LOAN_OBJECTS.map(item => ({ text: item, value: item }));
